// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"8b1558a9551d53aed0ce","532":"56bb3bb072c8dc4907f7","678":"8a8badaa0651f5b8add9","883":"90ea8f67202e3f64ed87"}[chunkId] + ".js";
};